export const assets = {
  spine: {},
  spineAtlas: {},
  atlas: {},
  component: { entity: {} },
}

export function addEntity(entity){
  assets.component.entity[entity.name] = entity
}

export  function parseAssets(resource) {
  const res = {}
  res.spine = {}
  res.spineAtlas = {}
  res.atlas = {}
  const trimPngExtension = (str) => {
    return str.replace(/.(png|jp[e]g)$/gi, '')
  }
  for (let resourceKey in resource) {
    if(resource.hasOwnProperty(resourceKey) && resourceKey.includes('animations')) {
      let st = resourceKey.split('/')
      res.spineAtlas[st[2]] = resource[resourceKey]
      assets.spineAtlas[st[2]] = resource[resourceKey]
    }

    if(resource.hasOwnProperty(resourceKey) && resourceKey.includes('animations')) {

      let st = resourceKey.split('/')
      if(resource[resourceKey].data.skeleton){
        res.spine[st[2]] = resource[resourceKey]
        assets.spine[st[2]] = resource[resourceKey]
      }

    }

    if(resource.hasOwnProperty(resourceKey) && resourceKey.includes('atlases')) {
      if(resource[resourceKey].textures !== undefined){
        let tex = resource[resourceKey].textures
        for (let key in tex) {
          if(tex.hasOwnProperty(key)){
            let newKey =  trimPngExtension (key.substr(key.lastIndexOf('/') + 1))
            res.atlas[newKey] = tex[key]
            assets.atlas[newKey] = tex[key]
          }
        }
      }
    }
  }
  return res
}
